import React, { useEffect, useState } from "react";
import { submissionFields, visibilityOptions } from "./SubmissionComponent";
import {
  Button,
  Divider,
  Grid,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import "../../assets/css/summaryPractice.css";
import { CircularProgress } from "@mui/material";
import { actions, service } from "../../model";
import { generatePDF } from "../../utils/generate_pdf";
import { EventAvailableSharp } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { generateOthePDF_CCK } from "../../utils/other_generate_pdf";

const SummaryPracticeAdmin = ({
  practice,
  practice_object,
  practice_id,
  setAdminNote,
  saveNote,
  documentPractice,
  documentPracticeClient,
}) => {
  const reduxObject = JSON.parse(localStorage.getItem("redux_object") || "{}");
  const accessToken = reduxObject ? reduxObject.accessToken : null;
  const dispatch = useDispatch();
  const [documentDownload, setDocumentDownload] = useState({});
  const [documentDownloadClient, setDocumentDownloadClient] = useState({});
  const [adminNotes, setAdminNotes] = useState(
    practice_object?.note_admin ?? "",
  );
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      practice_object === undefined ||
      (practice_object && Object.keys(practice_object).length === 0)
    ) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [practice_object]);

  useEffect(() => {
    if (practice_object?.note_admin !== undefined) {
      setAdminNotes(practice_object.note_admin ?? "");
    }
  }, [practice_object]);

  useEffect(() => {
    if (practice_id) {
      fetch(process.env.REACT_APP_API_ENDPOINT + "download-file-practice", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify({ practice_id: practice_id.toString() }),
      })
        .then((response) => response.json())
        .then((data) => {
          setDocumentDownload(data);
        })
        .catch((error) => {
          console.error(error);
        });
    }

    if (practice_id) {
      fetch(process.env.REACT_APP_API_ENDPOINT + "download-file-new-customer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        body: JSON.stringify({ practice_id: practice_id.toString() }),
      })
        .then((response) => response.json())
        .then((data) => {
          setDocumentDownloadClient(data);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, []);

  const handleDownload = (index) => {
    if (typeof document !== "undefined") {
      const documentItem = documentDownload.files[index];

      const byteCharacters = atob(documentItem.file);
      const byteNumbers = Array.from(byteCharacters).map((char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);

      const getMimeType = (fileName) => {
        const ext = fileName.split(".").pop().toLowerCase();
        switch (ext) {
          case "pdf":
            return "application/pdf";
          case "jpg":
          case "jpeg":
            return "image/jpeg";
          case "png":
            return "image/png";
          case "docx":
            return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          case "msg":
            return "application/octet-stream";
          case "eml":
            return "message/rfc822";
          case "txt":
            return "text/plain";
          case "odt":
            return "application/vnd.oasis.opendocument.text";
          case "dot":
            return "application/msword";
          case "xml":
            return "application/xml";
          default:
            return null;
        }
      };

      const mimeType = getMimeType(documentItem.original_name);

      if (mimeType) {
        const blob = new Blob([byteArray], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;

        a.download = documentItem.original_name || "document";
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }
    } else {
      return;
    }
  };

  const handleDownloadClient = (index) => {
    if (typeof document !== "undefined") {
      const documentItem = documentDownloadClient.files[index];

      const byteCharacters = atob(documentItem.file);
      const byteNumbers = Array.from(byteCharacters).map((char) =>
        char.charCodeAt(0),
      );
      const byteArray = new Uint8Array(byteNumbers);

      const getMimeType = (fileName) => {
        const ext = fileName.split(".").pop().toLowerCase();
        switch (ext) {
          case "pdf":
            return "application/pdf";
          case "jpg":
          case "jpeg":
            return "image/jpeg";
          case "png":
            return "image/png";
          case "docx":
            return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          case "msg":
            return "application/octet-stream";
          case "eml":
            return "message/rfc822";
          case "txt":
            return "text/plain";
          case "odt":
            return "application/vnd.oasis.opendocument.text";
          case "dot":
            return "application/msword";
          case "xml":
            return "application/xml";
          default:
            return null;
        }
      };

      const mimeType = getMimeType(documentItem.original_name);

      if (mimeType) {
        const blob = new Blob([byteArray], { type: mimeType });
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;

        a.download = documentItem.original_name || "document";
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        URL.revokeObjectURL(blobUrl);
      }
    } else {
      return;
    }
  };

  const handleNoteChange = async (event) => {
    setAdminNotes(event);

    setAdminNote(event);
  };

  return (
    <>
      {isLoading ? (
        <>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <CircularProgress style={{ color: "#1b2838" }} />
          </div>
        </>
      ) : (
        <Grid
          container
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid
            item
            xs={11}
            sm={10}
            style={{
              overflowY: "auto",
              marginTop: "30px",
            }}
          >
            <Typography
              className="color-blue-dark"
              style={{ fontSize: "22px", fontWeight: 600 }}
            >
              Riepilogo pratica #{practice_object?.id}
            </Typography>

            {/* step 1  */}
            <Grid
              item
              xs={12}
              style={{
                marginTop: "20px",
              }}
            >
              {" "}
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <Typography
                    className="color-purple"
                    style={{
                      fontSize: "18px",
                      fontWeight: 500,
                    }}
                  >
                    Step 1 - Incarico
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />
              <Grid item xs={12}>
                <Typography className="color-blue-dark">
                  Nome della pratica: {practice?.Incarico?.Nome_pratica || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Dipartimento Elibra:{" "}
                  {practice?.Incarico?.Team_riferimento?.name || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Prodotto richiesto:{" "}
                  {practice?.Incarico?.Prodotto_richiesto?.name || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Valore associato alla pratica:{" "}
                  {practice?.Incarico?.valore_associato_pratica || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Responsabile della pratica:{" "}
                  {practice?.Incarico?.responsabile_pratica || ""}
                </Typography>{" "}
                <Typography className="color-blue-dark">
                  Source of business (SOB): {practice?.Incarico?.SOB || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Documenti di conferma dell'incarico:{" "}
                  {documentPractice.map((file, index) => (
                    <button
                      key={index}
                      onClick={() => handleDownload(index)}
                      className="color-purple"
                      style={{
                        background: "none",
                        border: "none",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      {file?.original_name_attached}
                    </button>
                  ))}
                </Typography>
              </Grid>
            </Grid>

            {/* step 2  */}
            <Grid
              item
              xs={12}
              style={{
                marginTop: "40px",
              }}
            >
              {" "}
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <Typography
                    className="color-purple"
                    style={{ fontSize: "18px", fontWeight: 500 }}
                  >
                    Step 2 - Cliente
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />
              <Grid item xs={12}>
                <Typography className="color-blue-dark">
                  Status: {practice?.cliente?.status || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Tipologia: {practice?.cliente?.tipologia || ""}
                </Typography>

                {practice?.cliente?.segmento_operatività && (
                  <Typography className="color-blue-dark">
                    Segmento di operatività:{" "}
                    {practice?.cliente?.segmento_operatività || ""}
                  </Typography>
                )}

                {practice?.cliente?.lingua_corrispondenza && (
                  <Typography className="color-blue-dark">
                    Lingua di corrispondenza:{" "}
                    {practice?.cliente?.lingua_corrispondenza || ""}
                  </Typography>
                )}

                {practice?.cliente?.tipologia === "Persona fisica italiana" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Nome: {practice?.cliente?.nome || ""}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Cognome: {practice?.cliente?.cognome || ""}
                    </Typography>

                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        <Typography className="color-blue-dark">
                          {practice?.cliente?.codice_fiscale && (
                            <>
                              Partita IVA o Codice fiscale:{" "}
                              {practice?.cliente?.codice_fiscale || ""}
                            </>
                          )}
                        </Typography>
                        <Typography className="color-blue-dark">
                          {practice?.cliente?.comune && (
                            <>Comune: {practice?.cliente?.comune || ""}</>
                          )}
                        </Typography>
                        <Typography className="color-blue-dark">
                          {practice?.cliente?.indirizzo && (
                            <>
                              Indirizzo e Civico:{" "}
                              {practice?.cliente?.indirizzo || ""}
                            </>
                          )}
                        </Typography>
                        <Typography className="color-blue-dark">
                          {practice?.cliente?.CAP && (
                            <>CAP: {practice?.cliente?.CAP || ""}</>
                          )}
                        </Typography>

                        {practice?.cliente?.SDI && (
                          <Typography className="color-blue-dark">
                            Codice SDI o PEC: {practice?.cliente?.SDI}
                          </Typography>
                        )}

                        {practice?.cliente
                          ?.cliente_affiliato_gruppo_societari &&
                          practice?.cliente
                            ?.cliente_affiliato_gruppo_societari === "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente è affiliato a gruppi societari:{" "}
                              {
                                practice?.cliente
                                  ?.cliente_affiliato_gruppo_societari
                              }
                            </Typography>
                          )}

                        {practice?.cliente?.cliente_collegamento_societa && (
                          <Typography className="color-blue-dark">
                            Società/gruppo con cui il cliente è collegato:{" "}
                            {practice?.cliente?.cliente_collegamento_societa}
                          </Typography>
                        )}

                        {practice?.cliente?.cliente_ruolo && (
                          <Typography className="color-blue-dark">
                            Ruolo: {practice?.cliente?.cliente_ruolo}
                          </Typography>
                        )}

                        {practice?.cliente?.cliente_altro && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.cliente_altro}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>

                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}

                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>

                        {practice?.cliente?.altri_contatti === "Sì" && (
                          <Typography className="color-blue-dark">
                            Altri contatti: {practice?.cliente?.contatti || ""}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>

                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}

                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : practice?.cliente?.tipologia ===
                  "Persona fisica altro paese UE" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Nome: {practice?.cliente?.nome || ""}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Cognome: {practice?.cliente?.cognome || ""}
                    </Typography>
                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        {" "}
                        {practice?.cliente?.codice_fiscale && (
                          <Typography className="color-blue-dark">
                            VAT number o Fiscal code:{" "}
                            {practice?.cliente?.codice_fiscale || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.comune && (
                          <Typography className="color-blue-dark">
                            Comune: {practice?.cliente?.comune || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.indirizzo && (
                          <Typography className="color-blue-dark">
                            Indirizzo e Civico:{" "}
                            {practice?.cliente?.indirizzo || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.CAP && (
                          <Typography className="color-blue-dark">
                            CAP: {practice?.cliente?.CAP || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.SDI ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Codice SDI o PEC:{" "}
                              {practice?.cliente?.cognome || ""}
                            </Typography>
                          </>
                        ) : null}
                        {practice?.cliente
                          ?.cliente_affiliato_gruppo_societari &&
                          practice?.cliente
                            ?.cliente_affiliato_gruppo_societari === "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente è affiliato a gruppi societari:{" "}
                              {
                                practice?.cliente
                                  ?.cliente_affiliato_gruppo_societari
                              }
                            </Typography>
                          )}
                        {practice?.cliente?.cliente_collegamento_societa && (
                          <Typography className="color-blue-dark">
                            Società/gruppo con cui il cliente è collegato:{" "}
                            {practice?.cliente?.cliente_collegamento_societa}
                          </Typography>
                        )}
                        {practice?.cliente?.cliente_ruolo && (
                          <Typography className="color-blue-dark">
                            Ruolo: {practice?.cliente?.cliente_ruolo}
                          </Typography>
                        )}
                        {practice?.cliente?.cliente_altro && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.cliente_altro}
                          </Typography>
                        )}
                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>
                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>
                        {practice?.cliente?.altri_contatti === "Sì" ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Altri contatti:{" "}
                              {practice?.cliente?.contatti || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>
                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}
                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : practice?.cliente?.tipologia ===
                  "Persona fisica extra UE" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Nome: {practice?.cliente?.nome || ""}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Cognome: {practice?.cliente?.cognome || ""}
                    </Typography>
                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        {practice?.cliente?.comune && (
                          <Typography className="color-blue-dark">
                            Comune: {practice?.cliente?.comune || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.indirizzo && (
                          <Typography className="color-blue-dark">
                            Indirizzo e Civico:{" "}
                            {practice?.cliente?.indirizzo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.CAP && (
                          <Typography className="color-blue-dark">
                            CAP: {practice?.cliente?.CAP || ""}
                          </Typography>
                        )}

                        {practice?.cliente
                          ?.cliente_affiliato_gruppo_societari &&
                          practice?.cliente
                            ?.cliente_affiliato_gruppo_societari === "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente è affiliato a gruppi societari:{" "}
                              {
                                practice?.cliente
                                  ?.cliente_affiliato_gruppo_societari
                              }
                            </Typography>
                          )}

                        {practice?.cliente?.cliente_collegamento_societa && (
                          <Typography className="color-blue-dark">
                            Società/gruppo con cui il cliente è collegato:{" "}
                            {practice?.cliente?.cliente_collegamento_societa}
                          </Typography>
                        )}

                        {practice?.cliente?.cliente_ruolo && (
                          <Typography className="color-blue-dark">
                            Ruolo: {practice?.cliente?.cliente_ruolo}
                          </Typography>
                        )}

                        {practice?.cliente?.cliente_altro && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.cliente_altro}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>
                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>
                        {practice?.cliente?.altri_contatti === "Sì" ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Altri contatti:{" "}
                              {practice?.cliente?.contatti || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>

                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}

                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : practice?.cliente?.tipologia ===
                  "Persona giuridica italiana" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Denominazione sociale:{" "}
                      {practice?.cliente?.denominazione_sociale || ""}
                    </Typography>
                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        {practice?.cliente?.partita_iva && (
                          <Typography className="color-blue-dark">
                            Partiva IVA o Codice fiscale:{" "}
                            {practice?.cliente?.partita_iva || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.comune && (
                          <Typography className="color-blue-dark">
                            Comune: {practice?.cliente?.comune || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.indirizzo && (
                          <Typography className="color-blue-dark">
                            Indirizzo e Civico:{" "}
                            {practice?.cliente?.indirizzo || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.CAP && (
                          <Typography className="color-blue-dark">
                            CAP: {practice?.cliente?.CAP || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.SDI && (
                          <Typography className="color-blue-dark">
                            Codice SDI o PEC: {practice?.cliente?.SDI || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.appartiene_gruppo_societario ===
                          "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente appartiene a un gruppo societario:{" "}
                              {practice?.cliente?.appartiene_gruppo_societario ||
                                ""}
                            </Typography>
                          )}

                        {practice?.cliente?.denominazione_gruppo_holding && (
                          <Typography className="color-blue-dark">
                            Denominazione del gruppo/holding:{" "}
                            {practice?.cliente?.denominazione_gruppo_holding ||
                              ""}
                          </Typography>
                        )}

                        {practice?.cliente?.capogruppo && (
                          <Typography className="color-blue-dark">
                            Capogruppo (società controllante):{" "}
                            {practice?.cliente?.capogruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.relazione_cliente_gruppo && (
                          <Typography className="color-blue-dark">
                            Ruolo/relazione del cliente nel gruppo:{" "}
                            {practice?.cliente?.relazione_cliente_gruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.gruppo_societa_rilevante && (
                          <Typography className="color-blue-dark">
                            Società del gruppo rilevanti ai fini del mandato:{" "}
                            {practice?.cliente?.gruppo_societa_rilevante || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.altre_controparti && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.altre_controparti || ""}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>

                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}

                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>
                        {practice?.cliente?.altri_contatti === "Sì" ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Altri contatti:{" "}
                              {practice?.cliente?.contatti || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>

                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}

                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : practice?.cliente?.tipologia ===
                  "Persona giuridica altro paese UE" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Denominazione sociale:{" "}
                      {practice?.cliente?.denominazione_sociale || ""}
                    </Typography>

                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        {practice?.cliente?.partita_iva && (
                          <Typography className="color-blue-dark">
                            VAT number: {practice?.cliente?.partita_iva || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.comune && (
                          <Typography className="color-blue-dark">
                            Comune: {practice?.cliente?.comune || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.indirizzo && (
                          <Typography className="color-blue-dark">
                            Indirizzo e Civico:{" "}
                            {practice?.cliente?.indirizzo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.CAP && (
                          <Typography className="color-blue-dark">
                            CAP: {practice?.cliente?.CAP || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.appartiene_gruppo_societario ===
                          "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente appartiene a un gruppo societario:{" "}
                              {practice?.cliente?.appartiene_gruppo_societario ||
                                ""}
                            </Typography>
                          )}

                        {practice?.cliente?.denominazione_gruppo_holding && (
                          <Typography className="color-blue-dark">
                            Denominazione del gruppo/holding:{" "}
                            {practice?.cliente?.denominazione_gruppo_holding ||
                              ""}
                          </Typography>
                        )}

                        {practice?.cliente?.capogruppo && (
                          <Typography className="color-blue-dark">
                            Capogruppo (società controllante):{" "}
                            {practice?.cliente?.capogruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.relazione_cliente_gruppo && (
                          <Typography className="color-blue-dark">
                            Ruolo/relazione del cliente nel gruppo:{" "}
                            {practice?.cliente?.relazione_cliente_gruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.gruppo_societa_rilevante && (
                          <Typography className="color-blue-dark">
                            Società del gruppo rilevanti ai fini del mandato:{" "}
                            {practice?.cliente?.gruppo_societa_rilevante || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.altre_controparti && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.altre_controparti || ""}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>
                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>
                        {practice?.cliente?.altri_contatti === "Sì" ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Altri contatti:{" "}
                              {practice?.cliente?.contatti || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>

                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}

                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : practice?.cliente?.tipologia ===
                  "Persona giuridica extra UE" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Denominazione sociale:{" "}
                      {practice?.cliente?.denominazione_sociale || ""}
                    </Typography>
                    {practice?.cliente?.status === "Nuovo cliente" && (
                      <>
                        {practice?.cliente?.partita_iva && (
                          <Typography className="color-blue-dark">
                            VAT number: {practice?.cliente?.partita_iva || ""}
                          </Typography>
                        )}
                        {practice?.cliente?.comune && (
                          <Typography className="color-blue-dark">
                            Comune: {practice?.cliente?.comune || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.indirizzo && (
                          <Typography className="color-blue-dark">
                            Indirizzo e Civico:{" "}
                            {practice?.cliente?.indirizzo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.CAP && (
                          <Typography className="color-blue-dark">
                            CAP: {practice?.cliente?.CAP || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.appartiene_gruppo_societario ===
                          "Sì" && (
                            <Typography className="color-blue-dark">
                              Il cliente appartiene a un gruppo societario:{" "}
                              {practice?.cliente?.appartiene_gruppo_societario ||
                                ""}
                            </Typography>
                          )}

                        {practice?.cliente?.denominazione_gruppo_holding && (
                          <Typography className="color-blue-dark">
                            Denominazione del gruppo/holding:{" "}
                            {practice?.cliente?.denominazione_gruppo_holding ||
                              ""}
                          </Typography>
                        )}

                        {practice?.cliente?.capogruppo && (
                          <Typography className="color-blue-dark">
                            Capogruppo (società controllante):{" "}
                            {practice?.cliente?.capogruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.relazione_cliente_gruppo && (
                          <Typography className="color-blue-dark">
                            Ruolo/relazione del cliente nel gruppo:{" "}
                            {practice?.cliente?.relazione_cliente_gruppo || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.gruppo_societa_rilevante && (
                          <Typography className="color-blue-dark">
                            Società del gruppo rilevanti ai fini del mandato:{" "}
                            {practice?.cliente?.gruppo_societa_rilevante || ""}
                          </Typography>
                        )}

                        {practice?.cliente?.altre_controparti && (
                          <Typography className="color-blue-dark">
                            Altro: {practice?.cliente?.altre_controparti || ""}
                          </Typography>
                        )}

                        <Typography className="color-blue-dark">
                          E-mail di contatto principale:{" "}
                          {practice?.cliente?.email_principale || ""}
                        </Typography>

                        {practice?.cliente?.contatto_principale_CRM ? (
                          <>
                            <Typography className="color-blue-dark">
                              Contatto da aggiungere al CRM:{" "}
                              {practice?.cliente?.contatto_principale_CRM || ""}
                            </Typography>
                          </>
                        ) : null}

                        <Typography className="color-blue-dark">
                          E-mail di destinazione delle fatture:{" "}
                          {practice?.cliente?.email_fatture || ""}
                        </Typography>
                        {practice?.cliente?.altri_contatti === "Sì" ? (
                          <>
                            {" "}
                            <Typography className="color-blue-dark">
                              Altri contatti:{" "}
                              {practice?.cliente?.contatti || ""}
                            </Typography>
                          </>
                        ) : null}
                        <Typography className="color-blue-dark">
                          Il cliente è segnalato sulla base di una partnership
                          con LEXIA:{" "}
                          {practice?.cliente?.cliente_partnership || ""}
                        </Typography>

                        {practice?.cliente?.cliente_partnership === "Sì" && (
                          <Typography className="color-blue-dark">
                            Accordo sottostante:{" "}
                            {practice?.cliente?.accordo_cliente_partner || ""}
                          </Typography>
                        )}
                      </>
                    )}

                    {practice?.cliente?.cliente_provenienza && (
                      <Typography className="color-blue-dark">
                        Il cliente proviene da un'altra area LEXIA (cross
                        selling): {practice?.cliente?.cliente_provenienza || ""}
                      </Typography>
                    )}

                    {practice?.cliente?.cliente_provenienza === "Sì" && (
                      <Typography className="color-blue-dark">
                        Area:{" "}
                        {practice?.cliente?.cliente_area_provenienza || ""}
                      </Typography>
                    )}
                  </>
                ) : null}

                {documentPracticeClient.length > 0 &&
                  practice?.cliente?.status === "Nuovo Cliente" && (
                    <Typography className="color-blue-dark">
                      Documenti relativi al cliente:{" "}
                      {documentPracticeClient.map((file, index) => (
                        <button
                          key={index}
                          onClick={() => handleDownloadClient(index)}
                          className="color-purple"
                          style={{
                            background: "none",
                            border: "none",
                            textDecoration: "underline",
                            cursor: "pointer",
                          }}
                        >
                          {file?.original_name_attached}
                        </button>
                      ))}
                    </Typography>
                  )}
              </Grid>
            </Grid>

            {/* step 3: si mostra solo se c'è la risposta Sì/No */}
            {practice?.submission?.richiesta_submission && (
            <Grid
              item
              xs={12}
              style={{
                marginTop: "40px",
              }}
            >
              {" "}
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <Typography
                    className="color-purple"
                    style={{ fontSize: "18px", fontWeight: 500 }}
                  >
                    Step 3 - Submission
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />
              <Grid item xs={12}>
                {practice?.submission?.richiesta_submission && (
                  <Typography className="color-blue-dark">
                    Record submission: {practice.submission.richiesta_submission}
                  </Typography>
                )}
                {practice?.submission?.richiesta_submission === "Sì" &&
                  [
                    ...submissionFields,
                    { name: "visibility", label: "Visibilità operazione" },
                    ...(practice.submission.visibility === "confidential"
                      ? [
                          {
                            name: "confidential_details",
                            label: "Elementi di confidenzialità",
                          },
                        ]
                      : []),
                  ]
                    .filter((field) => practice.submission[field.name])
                    .map((field) => (
                      <Typography className="color-blue-dark" key={field.name}>
                        {field.label}:{" "}
                        {field.name === "visibility"
                          ? visibilityOptions.find(
                              (o) => o.value === practice.submission.visibility
                            )?.label || practice.submission.visibility
                          : practice.submission[field.name]}
                      </Typography>
                    ))}
              </Grid>
            </Grid>
            )}

            {/* step 4  */}
            <Grid
              item
              xs={12}
              style={{
                marginTop: "40px",
              }}
            >
              {" "}
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <Typography
                    className="color-purple"
                    style={{ fontSize: "18px", fontWeight: 500 }}
                  >
                    Step 4 - Compenso
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />
              <Grid item xs={12}>
                <Typography className="color-blue-dark">
                  Oggetto della pro-forma / fattura:{" "}
                  {practice?.compenso?.pro_forma_fattura || ""}
                </Typography>
                <Typography className="color-blue-dark">
                  Modalità di compenso:{" "}
                  {practice?.compenso?.modalità_compenso || ""}
                </Typography>

                {practice?.compenso?.modalità_compenso === "Forfait" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Compenso complessivo:{" "}
                      {practice?.compenso?.compenso_complessivo || ""} €
                    </Typography>
                    <Typography className="color-blue-dark">
                      Dettagli della fatturazione del compenso:{" "}
                      {practice?.compenso?.dettagli_fatturazione_compenso || ""}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Periodo di competenza: Dal{" "}
                      {practice?.compenso?.periodo_competenza_inizio || ""} Al{" "}
                      {practice?.compenso?.periodo_competenza_fine || ""}
                    </Typography>
                  </>
                ) : null}

                {practice?.compenso?.modalità_compenso ===
                  "Listino/Tariffa oraria" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Riferimento per il calcolo:{" "}
                      {practice?.compenso?.riferimento_calcolo || ""}{" "}
                      {practice?.compenso?.riferimento_calcolo ===
                        "Listino personalizzato"}{" "}
                    </Typography>

                    {practice.compenso.riferimento_calcolo ===
                      "Listino personalizzato" ? (
                      <>
                        <Typography className="color-blue-dark">
                          Tariffa specifica:{" "}
                          {practice?.compenso?.tariffa_specifica || ""} {""}
                        </Typography>
                      </>
                    ) : null}

                    {practice?.compenso
                      ?.note_compenso_listino_tariffa_oraria ? (
                      <Typography className="color-blue-dark">
                        Note sul compenso o Cap:{" "}
                        {
                          practice?.compenso
                            ?.note_compenso_listino_tariffa_oraria
                        }
                      </Typography>
                    ) : null}
                  </>
                ) : null}

                {practice?.compenso?.modalità_compenso === "Mista" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Tariffa oraria: {practice?.compenso?.tariffa_oraria || ""}{" "}
                      {practice?.compenso?.tariffa_oraria ===
                        "Listino personalizzato"}{" "}
                    </Typography>
                    {practice.compenso.tariffa_oraria ===
                      "Listino personalizzato" ? (
                      <>
                        <Typography className="color-blue-dark">
                          Tariffa specifica:{" "}
                          {practice?.compenso?.tariffa_specifica || ""} {""}
                        </Typography>
                      </>
                    ) : null}
                    <Typography className="color-blue-dark">
                      Dettagli del compenso a forfait e della sua combinazione
                      con il listino selezionato:{" "}
                      {practice?.compenso
                        ?.compenso_combinazione_forfait_listino || ""}
                    </Typography>
                  </>
                ) : null}

                <Typography className="color-blue-dark">
                  Percentuale di spese generali da applicare:{" "}
                  {practice?.compenso?.percentuale_spese || ""}
                </Typography>

                {practice?.compenso?.percentuale_spese ===
                  "Altra percentuale" ? (
                  <>
                    {" "}
                    <Typography className="color-blue-dark">
                      Percentuale specifica:{" "}
                      {practice?.compenso?.percentuale_spese_specifica || ""}{" "}
                      {""}%
                    </Typography>
                  </>
                ) : null}

                <Typography className="color-blue-dark">
                  Compenso ripartito con altri team:{" "}
                  {practice?.compenso?.compenso_condiviso || ""}
                </Typography>

                {practice?.compenso?.compenso_condiviso === "Sì" ? (
                  <>
                    {" "}
                    <Typography className="color-blue-dark">
                      Compenso ripartito con il team:{" "}
                      {practice?.compenso?.team_compenso_condiviso
                        ?.map((team) => team.name)
                        .join(" - ") || "Nessun team selezionato"}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Dettagli della ripartizione:{" "}
                      {practice?.compenso?.dettagli_divisione || ""}
                    </Typography>
                  </>
                ) : null}

                <Typography className="color-blue-dark">
                  Condizioni di pagamento:{" "}
                  {practice?.compenso?.condizioni_pagamento || ""}
                </Typography>

                <Typography className="color-blue-dark">
                  Compensi a soggetti in outsourcing:{" "}
                  {practice?.compenso?.compensi_outsourcing || ""}
                </Typography>

                {practice?.compenso?.compensi_outsourcing === "Sì" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Dettagli dei compensi per outsourcing:{" "}
                      {practice?.compenso?.dettagli_compensi_outsourcing || ""}
                    </Typography>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* step 5  */}
            <Grid
              item
              xs={12}
              style={{
                marginTop: "40px",
              }}
            >
              {" "}
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <Typography
                    className="color-purple"
                    style={{ fontSize: "18px", fontWeight: 500 }}
                  >
                    Step 5 - AML
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />
              <Grid item xs={12}>
                <Typography className="color-blue-dark">
                  Controlli AML: {practice?.AML?.controlli_AML}{" "}
                </Typography>

                {practice?.AML?.controlli_AML === "Sì" ? (
                  <>
                    <Typography className="color-blue-dark">
                      Tipologia di verifica:{" "}
                      {practice?.AML?.tipologia_verifica || ""}
                    </Typography>
                    <Typography className="color-blue-dark">
                      Livello di rischio: {practice?.AML?.livello_rischio || ""}
                    </Typography>
                  </>
                ) : null}
              </Grid>
            </Grid>

            {/* NOTE ADMIN  */}
            <Grid
              item
              xs={12}
              style={{
                marginTop: "40px",
                marginBottom: "50px",
              }}
            >
              <div style={{ display: "flex" }}>
                <Grid
                  item
                  xs={6}
                  style={{
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <Typography
                    className="color-purple"
                    style={{ fontSize: "18px", fontWeight: 500 }}
                  >
                    Note dell'amministrazione
                  </Typography>
                </Grid>
                <Grid
                  item
                  xs={6}
                  style={{ display: "flex", justifyContent: "flex-end" }}
                ></Grid>
              </div>
              <Divider className="divider-summary-practice" />

              <Grid item xs={11} md={6} style={{ marginBottom: "50px" }}>
                {practice_object?.practice_worked === 0 ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        height: "100%",
                        marginTop: "20px",
                      }}
                    >
                      <Typography className="color-blue-dark title-input">
                        Utilizza questo campo per inserire variazioni e appunti
                        relativi alla pratica. <br /> Attenzione! Una volta
                        approvata la pratica, le note saranno visibili anche al
                        suo responsabile.
                      </Typography>
                    </div>
                    <TextField
                      multiline
                      rows={7}
                      value={adminNotes}
                      style={{ marginTop: "10px" }}
                      placeholder="Inserisci"
                      variant="outlined"
                      onChange={(e) => handleNoteChange(e.target.value)}
                      fullWidth
                      InputProps={{
                        style: { color: "#1b2838" },
                        startAdornment: (
                          <div style={{ position: "absolute", bottom: "30px" }}>
                            <InputAdornment position="start">
                              <Button
                                variant="outlined"
                                className="button-bg-empty-small"
                                onClick={() =>
                                  saveNote(practice_id, adminNotes)
                                }
                                sx={{
                                  marginBottom: 0,
                                  padding: "2px 12px",
                                }}
                              >
                                <Typography
                                  className="color-blue-dark"
                                  style={{
                                    textTransform: "initial",
                                    fontSize: "14px",
                                    fontWeight: 500,
                                  }}
                                >
                                  Salva note
                                </Typography>
                              </Button>
                            </InputAdornment>
                          </div>
                        ),
                      }}
                    />
                  </>
                ) : (
                  <Typography className="color-blue-dark">
                    {practice_object?.note_admin &&
                      practice_object.note_admin.trim() !== "" &&
                      practice_object.note_admin.toLowerCase() !== "undefined"
                      ? practice_object.note_admin
                      : "Nessuna nota inserita"}
                  </Typography>
                )}
              </Grid>
            </Grid>

            <Button
              variant="contained"
              className="button-bg-purple-download-summary"
              onClick={() =>
                generatePDF(
                  practice_id,
                  practice,
                  practice_object,
                  adminNotes,
                  false,
                )
              }
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                Scarica riepilogo
              </Typography>
            </Button>

            {/* LASCIO COMMENTATO PER TEST PDF - CCK */}
            {/* <Button
              variant="contained"
              className="button-bg-purple-download-summary"
              onClick={() => generateOthePDF_CCK(practice_id, practice, false)}
            >
              <Typography
                className="color-light"
                sx={{
                  textTransform: "initial",
                  fontSize: { xs: "16px", sm: "18px" },
                  fontWeight: 500,
                }}
              >
                Scarica riepilogo cck
              </Typography>
            </Button> */}

            <Grid
              item
              xs={12}
              style={{
                marginTop: "30px",
                marginBottom: "100px",
              }}
            >
              {practice_object?.practice_worked === 0 ? (
                <Typography className="color-blue-dark">
                  Pratica inviata il{" "}
                  {new Date(practice_object?.updated_at).toLocaleString(
                    "it-IT",
                    {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    },
                  )}
                </Typography>
              ) : (
                <Typography className="color-blue-dark">
                  Pratica approvata il{" "}
                  {new Date(practice_object?.updated_at).toLocaleString(
                    "it-IT",
                    {
                      day: "2-digit",
                      month: "long",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    },
                  )}
                </Typography>
              )}
            </Grid>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default SummaryPracticeAdmin;
